<template>
  <el-drawer v-model="navigation.drawer" direction="rtl" :unique-opened="true" class="k-drawer">
    <div class="d-flex justify-content-center">
      <div>
        <img :src="agencyLogo" class="img-fluid pl-2" style="width: 120px" />
        <div class="w-100">{{ agencyName }}</div>
      </div>
    </div>
    <el-divider></el-divider>
    <el-menu :router="true" @select="navigation.drawer = false">
      <el-menu-item index="dashboard" route="/dashboard" class="menu-item-text">
        <IconDashboard></IconDashboard>
        Dashboard</el-menu-item
      >

      <el-menu-item index="search" :route="userStore.searchersLink" class="menu-item-text">
        <IconHomeSearch></IconHomeSearch>
        Buscadores</el-menu-item
      >
      <el-menu-item index="bookings" route="/booking" class="menu-item-text">
        <IconBookings></IconBookings>
        Reservas</el-menu-item
      >

      <!-- <el-sub-menu index="products" v-if="userStore.type !== 'adviser' && userStore.hasKudenix">
        <template #title>
          <span class="menu-item-text">
            <IconProduct></IconProduct>
            Producto Kudenix</span
          >
        </template>
        <el-menu-item-group>
          <el-menu-item index="products-1" route="/product/hotel" v-if="userStore.configuration.modules['hotels-kudenix']">Hoteles</el-menu-item>
          <el-menu-item index="products-2" route="/product/transfer" v-if="userStore.configuration.modules['transfers-kudenix']">Transportes</el-menu-item>

          <el-menu-item index="products-3" route="/product/ticket" v-if="userStore.configuration.modules['tickets-kudenix']">Tickets</el-menu-item>
        </el-menu-item-group>
      </el-sub-menu> -->

      <el-menu-item
        index="users"
        route="/user"
        class="menu-item-text"
        v-if="userStore.type !== 'adviser'"
      >
        <IconUsers></IconUsers>
        Usuarios</el-menu-item
      >
      <el-sub-menu index="settings" v-if="userStore.type !== 'adviser'">
        <template #title>
          <span class="menu-item-text">
            <IconSettings></IconSettings>
            Configuración</span
          >
        </template>
        <el-menu-item-group>
          <el-menu-item index="settings-1" route="/configuration"
            >Información De la Empresa</el-menu-item
          >
          <el-menu-item index="settings-2" route="/configuration/app">Aplicación</el-menu-item>
          <el-menu-item index="settings-3" route="/configuration/appearance"
            >Apariencia</el-menu-item
          >

          <el-menu-item index="settings-4" route="/configuration/commission">Comisión</el-menu-item>

          <el-menu-item
            index="settings-5"
            route="/configuration/providers"
            v-if="agency.showProviders"
            >Proveedores</el-menu-item
          >

          <el-menu-item index="settings-7" route="/configuration/integrations"
            >Integraciones</el-menu-item
          >
        </el-menu-item-group>
      </el-sub-menu>

      <el-menu-item
        index="markup"
        route="/markup"
        class="menu-item-text"
        v-if="userStore.type !== 'adviser'"
      >
        <IconMarkups></IconMarkups>
        Markups</el-menu-item
      >

      <el-menu-item
        index="whitelabels"
        route="/whitelabels"
        class="menu-item-text"
        v-if="userStore.type !== 'adviser' && userStore.hasWhiteLabels"
      >
        <IconPages></IconPages>
        White Labels</el-menu-item
      >

      <el-menu-item index="logout" route="/logout" class="menu-item-text">
        <IconLogout></IconLogout>

        Logout</el-menu-item
      >
    </el-menu>
  </el-drawer>
</template>

<script setup>
import IconHomeSearch from '../icons/IconHomeSearch.vue'
import IconSettings from '../icons/IconSettings.vue'
import IconProduct from '../icons/IconProduct.vue'
import IconUsers from '../icons/IconUsers.vue'
import IconBookings from '../icons/IconBookings.vue'
import IconMarkups from '../icons/IconMarkups.vue'
import IconLogout from '../icons/IconLogout.vue'
import useNavigationStore from '@/stores/navigation.js'
import { ref, watch, inject, computed } from 'vue'
import { useAgencyStore } from '@/stores/agency'
import { useUserStore } from '@/stores/user'
import IconDashboard from '../icons/IconDashboard.vue'
import IconPages from '../icons/IconPages.vue'

const navigation = useNavigationStore()
const drawer = ref(navigation.drawer)

watch(navigation.drawer, () => {
  drawer.value = navigation.drawer
})

const production = import.meta.env.VITE_VUE_APP_NODE_ENV === 'production'
const agency = useAgencyStore()

const userStore = useUserStore()
const { $get_image } = inject('$get_image')

const agencyName = computed(() => {
  return agency.name.length ? agency.name : 'Agencia Kudenix'
})

const agencyLogo = computed(() => {
  return agency.logo.length ? $get_image(agency.logo) : '@/assets/logo/logo-reduccion.png'
})
</script>
